import React from 'react'
import Head from 'next/head'
import Link from 'next/link'
import Hero from '../../components/Hero'
import Menu from '../../components/Menu'
import Block from '../../components/Block'
import { NextSeo } from 'next-seo'
import Talk from '../../components/Talk'
import RegistrationButton from '../../components/RegistrationButton'
import Footer from '../../components/Footer'
import { useRouter } from 'next/router'
import talks from '../../data/talks.yml'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fab, faGithub, faTwitter } from '@fortawesome/free-brands-svg-icons'

const Speaker = ({ query }) => {
  const router = useRouter()
  const { id } = router.query
  const trueId = id.replace(/.html$/,'') // '.html' is appended to the routing path when exporting, so remove it.
  const talk = talks[trueId];
  return (
    <div id="main-container">
      <NextSeo
        title={`${talk.name} | PyCon mini Hiroshima 2020`}
        description={`PyCon mini Hiroshima 2020 の講演者 ${talk.name} 氏の情報です。`}
        openGraph={{
        title: `${talk.name} | PyCon mini Hiroshima 2020`,
        description: `PyCon mini Hiroshima 2020 の講演者 ${talk.name} 氏の情報です。`
      }} />

      <header>
        <Menu />
      </header>

      <div role='main'>
        <RegistrationButton/>
        <div className='speaker'>
          <h1>{talk.name}</h1>
          { talk.image &&
            <figure className='person-picture' >
              <img src={talk.image.match(/^http/) ? talk.image : `../${talk.image}`} />
            </figure> }

          <ul className='social-links'>
            { talk.github &&
              <li className='github'><a href={`https://github.com/${talk.github}`}><FontAwesomeIcon icon={faGithub} /></a></li>}
            { talk.twitter &&
              <li className='twitter'><a href={`https://twitter.com/${talk.twitter}`}><FontAwesomeIcon icon={faTwitter} /></a></li>}
          </ul>

          <h2 className='title'>{talk.title}</h2>

          { talk.elevator_pitch &&
            <div className='elevator-pitch'>{talk.elevator_pitch.split('\n').map(i => <p>{i}</p>)}</div>
          }

          { talk.description && 
            <div className='description'><h3>詳しい内容説明</h3>{talk.description.split('\n').map(i => <p>{i}</p>)}</div>
          }

          <div className='detail talk'>
            { talk.target && <span className='target'>対象: {talk.target}</span> }
            <span className='type'>{talk.type}</span>
          </div>

          <div className='profile'>
            <div className='avatar-box'>
              <figure className='person-picture-s' >
                <img src={talk.image.match(/^http/) ? talk.image : `../${talk.image}`} />
              </figure>
            </div>
            <div>
              <div className='name-box'>
                <span className='name'>{talk.name}</span>
              </div>
              <div>
                <span className='description'>{talk.profile}</span><br/>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Footer />
    </div>
  )
}

export default Speaker;
